import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip'
import { Star } from 'lucide-react'

const DefaultTeamStar = () => (
  <Tooltip>
    <TooltipTrigger asChild>
      <span>
        <Star className='h-3.5 w-3.5 text-subscription-gold' />
      </span>
    </TooltipTrigger>
    <TooltipContent>Default team</TooltipContent>
  </Tooltip>
)

export default DefaultTeamStar
